import { gql } from '@apollo/client';

export const createPlcAlarmCode = gql`
  mutation createPlcAlarmCode($input: CreateOrUpdatePlcAlarmCode) {
    createPlcAlarmCode(input: $input) {
      id
      alarmCode
      alarmComment
      alarmExplanation
      alarmFix
      createdBy
      createdAt
      updater
      updatedAt
      deletedAt
    }
  }
`;
